import { Vector3 } from 'three';
import Entity, { IEntity } from '../abstract/Entity';
import { DEFAULT_PASSAGE_LENGTH } from '../../utils/constants';
import { IAttribute } from './AttributeModel';
import { getDefaultObjectId, ObjectType } from '../../utils/attributes/defaultObjectsAndAttributes';

export interface IPassage extends IEntity {
  position: Vector3;
  length: number;
  depth: number;
  angle: number;
}

class PassageModel extends Entity implements IPassage {
  position: Vector3;

  length: number;

  depth: number;

  angle: number;

  readonly filesApiId: number = getDefaultObjectId(ObjectType.Passage);

  constructor(position: Vector3, length = DEFAULT_PASSAGE_LENGTH, depth = 1, angle = 0, attributes: Array<IAttribute> = [], uuid: string | undefined = undefined) {
    super(attributes);
    if (uuid) {
      this.uuid = uuid;
    }
    this.position = position;
    this.length = length;
    this.depth = depth;
    this.angle = angle;
  }

  getPosition(): Vector3 {
    return this.position;
  }

  setPosition(position: Vector3): void {
    this.position = position;
  }

  getLength(): number {
    return this.length;
  }

  setLength(length: number): void {
    this.length = length;
  }

  getDepth(): number {
    return this.depth;
  }

  setDepth(depth: number): void {
    this.depth = depth;
  }

  getAngle(): number {
    return this.angle;
  }

  setAngle(angle: number): void {
    this.angle = angle;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      position: { x: this.position.x, y: this.position.y, z: this.position.z },
      length: this.length,
      depth: this.depth,
      angle: this.angle,
    };
  }
}

export default PassageModel;
